import { Stack, styled } from '@mui/material'
import SensitivityMatrixHeader from './SensitivityMatrixHeader'
import SensitivityMatrixLegend from './SensitivityMatrixLegend'
import SensitivityMatrixBody from './SensitivityMatrixBody'
import type { SensitivityMatrixBodyProps } from './SensitivityMatrixBody'
import { tokens } from 'ComponentLibrary'

type SensitivityMatrixProps = SensitivityMatrixBodyProps & {
    showInfoButton?: boolean
    hideHeader?: boolean
    copy?: Partial<SensitivityMatrixCopy>
    locale?: string
}

export type SensitivityMatrixCopy = {
    title: string
    infoTitle: string
    infoText: string
    legendLabel: string
    marketRentLabel: string
    discountRateLabel: string
    percentagePointUnit?: string
    marketValue: string
    deltaToMarketValue: string
    capitalValue: string
    actualMultiplier: string
    actualGrossInitialYield: string
}

const DEFAULT_SENSITIVITY_MATRIX_COPY: SensitivityMatrixCopy = {
    title: 'Sensitivitätsmatrix',
    infoTitle: 'Rundung',
    infoText: 'Die Ergebnisse werden in der Sensitivitätsmatrix ungerundet dargestellt, um Verzerrungen zu vermeiden.',
    legendLabel: 'Legende',
    marketRentLabel: 'MIETEN',
    discountRateLabel: 'LZ',
    percentagePointUnit: 'BP',
    marketValue: 'Marktwert',
    deltaToMarketValue: 'Delta zum Marktwert',
    capitalValue: 'Kapitalwert',
    actualMultiplier: 'Multiplikator IST',
    actualGrossInitialYield: 'Bruttoanf.-Rendite IST',
}

export function SensitivityMatrix({ sensitivityMatrix, showInfoButton, hideHeader, copy, locale = 'de-DE' }: SensitivityMatrixProps) {
    const resolvedCopy = { ...DEFAULT_SENSITIVITY_MATRIX_COPY, ...copy }

    return (
        <SensitivityMatrixContainer>
            {!hideHeader && <SensitivityMatrixHeader showInfoButton={showInfoButton} copy={resolvedCopy} />}
            <SensitivityMatrixBody sensitivityMatrix={sensitivityMatrix} copy={resolvedCopy} locale={locale} />
            <SensitivityMatrixLegend copy={resolvedCopy} />
        </SensitivityMatrixContainer>
    )
}

const SensitivityMatrixContainer = styled(Stack)`
    display: flex;
    width: 100%;
    padding: ${tokens.SizingSpacingNone};
    flex-direction: column;
    align-items: flex-start;
    gap: ${tokens.SizingSpacing150};
`
